(function () {
    'use strict';

    angular.module("imApp").factory("orderLineCreditsService", ['$ihttp', function ($ihttp) {
        let service = {
            getOrderLineCredits: function (parms) {
                return $ihttp.post({
                    method: 2756,
                    parameters: parms || {}
                });
            },
            listSelectionIds: function (parms) {
                return $ihttp.post({
                    method: 2759,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
